import { render, staticRenderFns } from "./CompanySection.vue?vue&type=template&id=3932b2f6&scoped=true"
import script from "./CompanySection.vue?vue&type=script&lang=js"
export * from "./CompanySection.vue?vue&type=script&lang=js"
import style0 from "./CompanySection.vue?vue&type=style&index=0&id=3932b2f6&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3932b2f6",
  null
  
)

export default component.exports